<template>
  <div style="height:100%">
    <div id="account-header" class="settings-header pt-3 pl-3 grey lighten-4">
      <h1 color="black">
        <i class="mr-3 icon icon-organization"></i>
        {{$t('account.header-title')}}
      </h1>

      <!--  メニューバー  -->
      <v-toolbar flat dense height="35px">
        <v-toolbar-items>
          <v-btn v-if="userRole===rootRoleName" flat :class="{'current_page': $route.path === '/settings/pc_list'}" to="/settings/pc_list"><div>{{$t('account.header-pc')}}</div></v-btn>
          <v-btn v-if="userRole!==rootRoleName" flat :class="{'current_page': $route.path === '/settings/organizations_detail'}" to="/settings/organizations_detail"><div>{{$t('account.header-org')}}</div></v-btn>
          <v-btn v-if="userRole!==rootRoleName" flat :class="{'current_page': $route.path === '/settings/user_list'}"  to="/settings/user_list"><div>{{$t('account.header-user')}}</div></v-btn>
          <v-btn v-if="userRole!==rootRoleName" flat :class="{'current_page': $route.path === '/settings/user_invite'}" to="/settings/user_invite"><div>{{$t('account.header-invite')}}</div></v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </div>

    <router-view></router-view>

  </div>
</template>

<script>
import config from '@/config.js'

export default {
  components: {
  },
  data () {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: config.role.Root
    }
  },
  methods: {
    init () {
    }
  },
  mounted () {
    this.init()
  },
  updated () {
  }
}
</script>

<style>
#account-header {
  height: 90px;
  background: red;
}
#account-header .btn--active >.btn__content {
  color: rgba(0,0,0,0);
}
#account-header .btn--active >.btn__content div{
  height: 100%;
  color: #000;
  font-weight: bold;
  border-bottom: #000 2px solid !important;
  padding-top: 7px; /* TODO:直書き*/
}

</style>



// WEBPACK FOOTER //
// Account.vue?7a109ad0